var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    staticClass: "label-modal",
    attrs: {
      title: _vm.$t("快捷配置"),
      visible: _vm.configVisiable,
      width: 1200,
      footer: null
    },
    on: {
      cancel: _vm.closeAddVisible,
      ok: _vm.closeAddVisible
    }
  }, [_c("div", {
    staticClass: "quick-configuration"
  }, [_c("a-card", {
    staticClass: "function-list",
    attrs: {
      title: _vm.$t("组件函数")
    }
  }, _vm._l(_vm.functionResource, function (item, index) {
    return _c("p", {
      key: item.name,
      staticClass: "list-item",
      class: {
        "list-item": true,
        "list-item-active": _vm.editorValue.indexOf(item.mark) !== -1
      },
      attrs: {
        title: item.mark + " " + item.name
      },
      on: {
        click: function ($event) {
          return _vm.toggerSelect(item, index);
        }
      }
    }, [_vm._v(" " + _vm._s(item.mark + " " + item.name) + " ")]);
  }), 0), _c("div", {
    staticClass: "right-container"
  }, [_c("a-button", {
    staticStyle: {
      position: "absolute",
      top: "280px",
      right: "25px",
      "z-index": "1000"
    },
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.copyFunction
    }
  }, [_vm._v(_vm._s(_vm.$t("复制")))]), _c("textarea", {
    ref: "codeMirrorBox",
    staticClass: "function-edit",
    attrs: {
      editorValue: _vm.editorValue
    }
  }), _vm._v(" "), _c("div", {
    staticClass: "right-bottom"
  }, [_c("a-card", {
    staticClass: "function-description",
    attrs: {
      title: _vm.$t("函数说明")
    }
  }, [_c("h4", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.selectFunctionItem && _vm.selectFunctionItem.mark,
      expression: "selectFunctionItem && selectFunctionItem.mark"
    }]
  }, [_vm._v(" " + _vm._s(_vm.selectFunctionItem.mark + " " + _vm.selectFunctionItem.name) + " ")]), _c("p", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.selectFunctionItem && _vm.selectFunctionItem.mark,
      expression: "selectFunctionItem && selectFunctionItem.mark"
    }],
    staticClass: "function-paragraph"
  }, [_vm._v(" 表达式：" + _vm._s(_vm.selectFunctionItem.example) + " ")]), _c("p", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.selectFunctionItem && _vm.selectFunctionItem.mark,
      expression: "selectFunctionItem && selectFunctionItem.mark"
    }],
    staticClass: "function-paragraph"
  }, [_vm._v(" 输入：" + _vm._s(_vm.selectFunctionItem.inputDescription) + " ")]), _c("p", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.selectFunctionItem && _vm.selectFunctionItem.mark,
      expression: "selectFunctionItem && selectFunctionItem.mark"
    }],
    staticClass: "function-paragraph"
  }, [_vm._v(" 输出：" + _vm._s(_vm.selectFunctionItem.outputDescription) + " ")])]), _c("a-card", {
    staticClass: "data-resource",
    attrs: {
      title: _vm.$t("列字段")
    }
  }, [_vm.type === "table" ? _c("div", _vm._l(_vm.tableConfigList, function (item, index) {
    return _c("p", {
      key: item.mark + index,
      class: {
        "row-text": true
      },
      attrs: {
        title: item.label
      },
      on: {
        click: function ($event) {
          return _vm.addRest(item);
        }
      }
    }, [_vm._v(" " + _vm._s(index + 1 + ".")), _c("span", {
      staticClass: "marginL15",
      class: {
        "row-text-active-color": _vm.editorValue.indexOf(item.label) !== -1
      }
    }, [_vm._v(_vm._s(item.label))])]);
  }), 0) : _c("div", [_c("a-select", {
    staticStyle: {
      width: "60%"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("关联数据源")
    },
    model: {
      value: _vm.associateDataSource,
      callback: function ($$v) {
        _vm.associateDataSource = $$v;
      },
      expression: "associateDataSource"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "system"
    }
  }, [_vm._v(_vm._s(_vm.$t("系统内置")))]), _c("a-select-option", {
    attrs: {
      value: "dynamic"
    }
  }, [_vm._v(_vm._s(_vm.$t("动态获取")))]), _c("a-select-option", {
    attrs: {
      value: "filter"
    }
  }, [_vm._v(_vm._s(_vm.$t("筛选项")))])], 1), _c("p", {
    staticClass: "select-tip"
  }, [_vm._v(_vm._s(_vm.$t("选择数据源") + "："))]), _c("div", {
    staticClass: "list-container"
  }, [_c("el-cascader-panel", {
    staticStyle: {
      width: "100%",
      overflow: "scroll"
    },
    attrs: {
      options: _vm.cascaderData,
      props: _vm.configProp,
      empty: "664"
    },
    on: {
      change: _vm.cascaderChange
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        node,
        data
      }) {
        return [!node.isLeaf ? _c("span", {
          attrs: {
            title: _vm.$t(data.label)
          }
        }, [_vm._v(" " + _vm._s(_vm.$t(data.label)) + " ")]) : _c("span", {
          attrs: {
            title: data.label
          }
        }, [_vm._v(_vm._s(data.label))])];
      }
    }]),
    model: {
      value: _vm.cascaderValue,
      callback: function ($$v) {
        _vm.cascaderValue = $$v;
      },
      expression: "cascaderValue"
    }
  })], 1)], 1)])], 1)], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };